import { useRef } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { attachmentIdentity } from '../api/attachments';
import { useHelpdeskRuntime, type FormInput } from './runtime';
export function useRuntimeCreate() {
  const runtime = useHelpdeskRuntime();
  const client = useQueryClient();
  const admission = useRef<{ payload: string; key: string } | null>(null);
  return useMutation({
    mutationFn: (input: FormInput & { files: File[] }) => {
      const { files, ...body } = input;
      const payload = JSON.stringify([runtime.scope, body, files.map(attachmentIdentity)]);
      if (admission.current?.payload !== payload)
        admission.current = { payload, key: crypto.randomUUID() };
      return runtime.create(body, admission.current.key, files);
    },
    retry: false,
    onSuccess: () => {
      admission.current = null;
      void client.invalidateQueries({ queryKey: ['helpdesk', runtime.scope, 'list'] });
    },
  });
}
export function useRuntimeReply(taskId: string) {
  const runtime = useHelpdeskRuntime();
  const client = useQueryClient();
  const admission = useRef<{ payload: string; key: string } | null>(null);
  return useMutation({
    mutationFn: (input: {
      message: string;
      kind?: 'support-reply' | 'internal-comment';
      files: File[];
      delivery?: { channelId: string };
    }) => {
      const { files, ...body } = input;
      const payload = JSON.stringify([runtime.scope, taskId, body, files.map(attachmentIdentity)]);
      if (admission.current?.payload !== payload)
        admission.current = { payload, key: crypto.randomUUID() };
      return runtime.reply(taskId, body, admission.current.key, files);
    },
    retry: false,
    onSuccess: () => {
      admission.current = null;
      if (runtime.audience === 'staff') {
        void client.invalidateQueries({
          queryKey: ['helpdesk', runtime.scope, 'article-generation', taskId],
        });
        void client.invalidateQueries({
          queryKey: ['helpdesk', runtime.scope, 'detail', taskId],
        });
      }
    },
  });
}
